import React from 'react';
import ReactDOM from 'react-dom/client';
import ModalityApp from './ModalityApp';
import ErrorBoundary from './ErrorBoundary';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <ModalityApp />
    </ErrorBoundary>
  </React.StrictMode>
); 